import http from "../utils/fetch"

const isProduction = process.env.NODE_ENV === "production"
const gateway =  process.env.REACT_APP_GATEWAY
const projectId = '1'

// 注册账号
export function register(params: {
	userName: string
	phoneNumber: string
	password: string
	verifyCode: string
}) {
	return http.post(`${gateway}/api/login/register`, {
		body: JSON.stringify({
			...params,
			projectId,
		}),
	})
}

// 账户登录
export function login(params: {
	phoneNumber?: string
	password?: string
	loginType: string
	networkId?: string
	userName?: string
}) {
	return http.post(`${gateway}/api/login/loginnew`, {
		body: JSON.stringify({
			...params,
			projectId,
		}),
	})
}

// 发送短信验证码
export function sendCode(params: { phoneNumber: string }) {
	return http.post(`${gateway}/api/login/sendCode`, {
		body: JSON.stringify({
			...params,
			projectId,
		}),
	})
}

// 找回密码
export function retrievePassword(params: {
	phoneNumber: string
	password: string
	verifyCode: string
}) {
	return http.post(`${gateway}/api/login/retrievePassword`, {
		body: JSON.stringify({
			...params,
			projectId,
		}),
	})
}

// 权限菜单
export function getRoleInfoNew(params: { userId: string, accessToken: string }) {
	if (!isProduction) {
		return import("../api/auth.json")
	}
	return http.post(`gateway/getRoleInfoNew`, {
		body: JSON.stringify({
			access_token: params.accessToken,
			userId: String(params.userId),
			projectId,
		}),
	})
}
